import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Euro_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.5698 5.75H2C1.58579 5.75 1.25 6.08579 1.25 6.5C1.25 6.91421 1.58579 7.25 2 7.25H3.28427C3.26161 7.49645 3.25 7.74671 3.25 8C3.25 8.25329 3.26161 8.50355 3.28427 8.75H2C1.58579 8.75 1.25 9.08579 1.25 9.5C1.25 9.91421 1.58579 10.25 2 10.25H3.5698C4.31909 12.7888 6.34253 14.75 8.88099 14.75C10.2971 14.75 11.5704 14.1271 12.5361 13.1398C12.8258 12.8437 12.8206 12.3689 12.5245 12.0792C12.2283 11.7896 11.7535 11.7948 11.4639 12.0909C10.7381 12.8329 9.83691 13.25 8.88099 13.25C7.31014 13.25 5.83612 12.089 5.1486 10.25H8.5C8.91421 10.25 9.25 9.91421 9.25 9.5C9.25 9.08579 8.91421 8.75 8.5 8.75H4.79206C4.76437 8.50534 4.75 8.25496 4.75 8C4.75 7.74504 4.76437 7.49466 4.79206 7.25H8.5C8.91421 7.25 9.25 6.91421 9.25 6.5C9.25 6.08579 8.91421 5.75 8.5 5.75H5.1486C5.83612 3.91098 7.31014 2.75 8.88099 2.75C9.83691 2.75 10.7381 3.16709 11.4639 3.90907C11.7535 4.20517 12.2283 4.21041 12.5245 3.92076C12.8206 3.63111 12.8258 3.15627 12.5361 2.86016C11.5704 1.87288 10.2971 1.25 8.88099 1.25C6.34253 1.25 4.31908 3.21115 3.5698 5.75Z"
            />
        </SvgStyled>
    );
};

export default Euro_xs;
